var ThreejsDefaults = require("../package/threejsDefaults");
var THREE = require("three");
var lib_geometry = require("lib-geometry"); 
// this is a module class, meant to be mixed in to other classes that should be able to build themselves as 3d geometry.
// it exposes an api, which when mixed in, will be attached to the target classes prototype.  
// anything not a part of that API (not a part of the returned object) is private, the target class will not be able to access them.
var Model3d  = (function(){


    function initModelHandlers(){
        // any time anything changes we want to clear the cache.
        this._geometryInfo = null;
        if(this.onBubble) this.onBubble("clearGeometryCache", clearCache);
    }

    function clearCache(){
        // any time anything changes we want to clear the cache.
         this._geometryInfo = null;
    }

    // moved this function into the model from the packageData.  The reason is because, in order for the error case
    // to work correctly, we need to attempt to build the geometry before actually setting the model as the package's model.
    // when inside the package data that was impossible without double calculation, since the actual setting of the model will reset any cache.
    // however in here i can cache the geometry on the model instance before attaching it to the package, and when attached that cache remains.
    function getModelCache(){
         return this._geometryInfo;
     }

    function hasModelCache(){
         if(  this._geometryInfo ) return true;
         return false;
     }


     function buildFromFiles(objFile, mtlFile) {
            var defaultMaterial = (ThreejsDefaults.packageMaterial)? ThreejsDefaults.packageMaterial : new THREE.MeshBasicMaterial({color: 0xffffff});
            var group = new THREE.Group();
            group.matrixAutoUpdate = false;

            var geometry = null;
            
            if(objFile && mtlFile) {
                geometry = _addObjectToGroup(objFile, mtlFile, group);
            } else if(objFile) {
                geometry = _getMeshFromFile(objFile);
                var mesh = geometry.toThreejsMesh(defaultMaterial);
                group.add(mesh);
            }

            this._geometryInfo = [group, geometry];

            return this._geometryInfo;
    }
    
    function buildFusionPlaceholder() {
           var defaultMaterial =  new THREE.MeshBasicMaterial({color: 0xff9955});
            var group = new THREE.Group();
            group.matrixAutoUpdate = false;
            var geometry = _getBoxMesh( 1000, 1000, 1000);
            var mesh = geometry.toThreejsMesh(defaultMaterial);
            group.add(mesh);
            this._geometryInfo = [group, geometry]
            return this._geometryInfo;
    }
    
    function buildEmptyPlaceholder() {
           var defaultMaterial =  new THREE.MeshBasicMaterial({color: 0xffffff});
            var group = new THREE.Group();
            group.matrixAutoUpdate = false;
            var geometry = _getBoxMesh( 0, 0, 0);
            var mesh = geometry.toThreejsMesh(defaultMaterial);
            group.add(mesh);
            this._geometryInfo = [group, geometry]
            return this._geometryInfo;
    }

     function buildFromBox(x, y, z) {
            var defaultMaterial = (ThreejsDefaults.packageMaterial)? ThreejsDefaults.packageMaterial : new THREE.MeshBasicMaterial({color: 0xffffff});
             var group = new THREE.Group();
             group.matrixAutoUpdate = false;
             var geometry = _getBoxMesh( x, y, z );
             var mesh = geometry.toThreejsMesh(defaultMaterial);
             group.add(mesh);
             this._geometryInfo = [group, geometry]
             return this._geometryInfo;
    }


    /******************/ // API
    return {
            initModelHandlers: initModelHandlers,
            clearCache: clearCache,
            getModelCache: getModelCache,
            hasModelCache: hasModelCache,
            buildFromFiles: buildFromFiles,
            buildFusionPlaceholder: buildFusionPlaceholder,
            buildEmptyPlaceholder: buildEmptyPlaceholder,
            buildFromBox: buildFromBox
    };

    /**********************************************************************************/ // private stuff
 

    function _addObjectToGroup(objFile, matFile, group){
        var mesh = new lib_geometry.TriangleMesh();
        var obj = mesh.getObjWithMaterial(objFile, matFile);
        obj.matrixAutoUpdate = false;
        mesh.scale(1000, 1000, 1000);
        var matrix = new THREE.Matrix4();
        matrix.makeScale(1000, 1000, 1000);
        obj.matrix = matrix;
        group.add(obj);
        return mesh;
    }

    // used when no material file
    function _getMeshFromFile(objFile){
        var mesh = new lib_geometry.TriangleMesh();
        mesh.fromObjFile(objFile);
        mesh.scale(1000, 1000, 1000);
        return mesh;
    }


    // used when no fileRef
    function _getBoxMesh(x, y, z){
        var mesh = new lib_geometry.TriangleMesh();
        mesh.fromBox(x, y, z);
        return mesh;
    }

})();

module.exports = Model3d